<template>
  <div class="row">
    <div class="col-xs-12 scroll">
      <div v-if="detalhes.dado.periodicidade === 6">
        <h3>Tabela</h3>
        <table class="table table-striped">
          <thead>
            <th>
              Período
            </th>
            <th v-if="detalhes.dado.tipo != 'T'">
              Valores
            </th>
            <th v-if="detalhes.dado.tipo == 'T'">
              Ações
            </th>
          </thead>
          <tbody>
            <tr v-for="valor in detalhes.valores" :key="valor.codigo">
              <td>
                {{ valor.data }}
              </td>
              <td v-if="detalhes.dado.tipo != 'T'">
                {{ formatValue(valor.valor) }}
              </td>
              <td v-if="detalhes.dado.tipo == 'T'">
                {{ valor.descricao }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="detalhes.dado.periodicidade === 1">
        <h3>Tabela</h3>
        <table>
          <thead>
            <th v-for="(item, index) in dados_tabela.header" :key="index">
              {{ item }}
            </th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dados_tabela.body" :key="index">
              <td v-for="(subitem, subindex) in item" :key="subindex">
                {{ subitem }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detalhes: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  methods: {
    formatValue(value) {
      let val = value
      switch (this.detalhes.dado.tipo) {
        case 'D':
          val = (value / 1).toFixed(2).replace('.', ',')
          val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          break
        case 'I':
          val = (value / 1).toFixed(0)
          val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          break
      }

      return val
    } /*
      Retorna um objeto contendo os anos como propriedades e 
      cada propriedade contém um array de 12 posições representando os meses.
      Ex: { 2019: [1,2,3,4,5,6,7,8,9,10,11,12], 2020: [1,2,3,4,5,6,7,8,9,10,11,12] }
     */,
    retornarObjetoMensal() {
      const meses = [...this.meses]
      const dados = [...this.valores]
      let year_base = {}
      let value_base = new Array(12).fill(0)

      for (let index = 0; index < dados.length; index++) {
        const element = dados[index]
        const data = new Date(dados[index].data)
        const ano = data.getFullYear()
        const mes = data.getMonth()

        if (!year_base[ano]) {
          year_base[ano] = [...value_base]
        }

        year_base[ano].splice(mes, 1, element.valor)
      }

      return year_base
    }
  },
  computed: {
    dados_tabela() {
      const dados_mensal = this.retornarObjetoMensal()
      const anos = Object.keys(dados_mensal)
      let retorno = {
        header: ['', ...this.meses],
        body: []
      }

      for (let index = 0; index < anos.length; index++) {
        const ano = anos[index]
        retorno.body.push([ano, ...dados_mensal[ano]])
      }

      return retorno
    }
  }
}
</script>

<style scoped>
.scroll {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dados/TabelaValores.vue